import React from 'react';
import { Container, Row, Col, NavbarBrand } from 'reactstrap';
import Footer from '@components/Footer';

class ConfirmCompliance extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="simple-page" style={{paddingTop: '80px'}}>
                <header className="app-header navbar">
                    <Container className="fluid">
                        <div className="fp-top">
                            <Row>
                                <Col><NavbarBrand href="https://www.corlytics.com"></NavbarBrand></Col>
                            </Row>
                        </div>
                    </Container>
                </header>
                <Container>
                    <Row>
                        <Col>
                            <div className="card">
                                <div className="card-header">Confirm Compliance</div>
                                <div className="card-block">
                                    <Row className="mb-3">
                                        <Col xs={2} className="font-weight-bold text-right">User Name:</Col>
                                        <Col><input type="text" name="userName" className="form-control" /></Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Col xs={2} className="font-weight-bold text-right">Email:</Col>
                                        <Col><input type="text" name="email" className="form-control" /></Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <Col xs={2} className="font-weight-bold text-right">Case Title:</Col>
                                        <Col><input type="text" name="caseTitle" className="form-control" /></Col>
                                    </Row>
                                
                                </div>
                            </div>                        
                        </Col>
                    </Row>
                </Container>
                <Footer />
            </div>
        )
    }
    
}

export default ConfirmCompliance;


// WEBPACK FOOTER //
// ./src/views/Pages/ConfirmCompliance/ConfirmCompliance.js